// src/pages/mallkiosk/AttractScreen.js
// Idle loop — default screen, returned to after timeout/order completion.
// FUTURE: featured-items row insertion point is marked below.
import React, { useEffect, useState } from 'react';

export default function AttractScreen({ mall, onStart }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), 50); return () => clearTimeout(t); }, []);

  return (
    <div
      onClick={onStart}
      onTouchStart={onStart}
      style={{
        position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', cursor: 'pointer', userSelect: 'none',
        background: 'radial-gradient(circle at 50% 30%, var(--bg2), var(--bg))',
        opacity: visible ? 1 : 0, transition: 'opacity .6s ease',
      }}>
      <style>{`
        @keyframes mk-pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.06); } }
      `}</style>

      {mall?.logo
        ? <img src={mall.logo} alt="" style={{ width: 140, height: 140, objectFit: 'contain', marginBottom: 28 }} />
        : <div style={{ fontSize: 100, marginBottom: 28 }}>🏬</div>
      }

      <div style={{ fontSize: 56, fontWeight: 800, color: 'var(--text)', marginBottom: 16, textAlign: 'center' }}>
        {mall?.name || 'Food Court'}
      </div>
      <div style={{ fontSize: 24, color: 'var(--text2)', marginBottom: 80 }}>
        Order from any stall, all in one place
      </div>

      {/* FUTURE: rotating featured-items row would go here */}

      <div style={{
        padding: '26px 64px', fontSize: 34, fontWeight: 800, borderRadius: 70,
        background: 'var(--accent)', color: 'var(--button-text)',
        boxShadow: '0 0 60px var(--accent)', animation: 'mk-pulse 1.8s ease-in-out infinite',
      }}>
        👆 Tap anywhere to start
      </div>
    </div>
  );
}
